var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgVideo = function SvgVideo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.342 11.316-20-9.997a2.987 2.987 0 0 0-2.919.131A2.981 2.981 0 0 0 1 4.004v19.995a2.98 2.98 0 0 0 1.423 2.551 2.987 2.987 0 0 0 2.919.132l20-9.998A2.984 2.984 0 0 0 27 14.001a2.985 2.985 0 0 0-1.658-2.685Zm-.895 3.578-20 9.998a.986.986 0 0 1-.973-.044.989.989 0 0 1-.474-.85V4.002c0-.502.332-.762.474-.85a.986.986 0 0 1 .973-.044l20 9.997A.982.982 0 0 1 25 14a.982.982 0 0 1-.553.894Z",
    fill: "currentColor"
  })));
};
export default SvgVideo;